// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage_errorPage__b4+zC","goBack":"errorPage_goBack__gcPsk"};